/**
 * کدام دستِ فیکسچرِ دمو — فارسی یا انگلیسی.
 *
 * `store.ts` فقط از این‌جا می‌خواند، تا انتخابِ زبان یک‌جا باشد و نه پخش‌شده
 * در ده صدا زدن. `demoLang` از `EXPO_PUBLIC_DEMO_LANG` می‌آید و پیش‌فرضش
 * فارسی‌ست، پس رفتارِ امروزِ دمو دست‌نخورده می‌ماند.
 *
 * ⚠️ هر دو ماژول **بارگذاری** می‌شوند، چون `import` ایستاست و `fixturesEn`
 * هم خودش روی `fixtures` سوار است. این عمدی‌ست: `import()` پویا این‌جا یعنی
 * ساختِ استور async شود، که برای صرفه‌جوییِ چند کیلوبایت در مسیری که فقط
 * حالتِ دمو از آن رد می‌شود معامله‌ی بدی‌ست.
 */
import { demoLang } from '../lib/demo.ts';
import * as FA from './fixtures.ts';
import * as EN from './fixturesEn.ts';

const F = demoLang === 'en' ? EN : FA;

export const {
  DEMO_PROFILE, SARA, ARASH, NEGAR, KIAN, MARYAM,
  demoFriends, demoSignals, demoRecipients, demoPlans, demoMessages,
  demoNotifications, demoContacts, demoGroups, demoTags, demoEvents,
  demoBusinesses, demoAvailability, DEMO_NOTIF_PREFS,
} = F;
